import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function ContactPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-88">
      {/* Hero */}
      <section className="relative py-32 bg-gray-900 overflow-hidden" data-id="element-89">
        <div className="absolute inset-0" data-id="element-90">
          <img src="https://cdn.magicpatterns.com/uploads/aSX1WwvkFskPr9R4e8Xsp4/pexels-gistsandthrills-4252245.jpg" alt="Two people using smartphones" className="w-full h-full object-cover opacity-40 object-top" data-id="element-91" />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/70 to-transparent" data-id="element-92"></div>
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-93">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight" data-id="element-94">
            Get in Touch
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto" data-id="element-95">
            Have questions about our services? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section id="contact-info" className="py-24" data-id="element-96">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
          <div className="text-center mb-16" data-id="element-98">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-99">
              Contact Information
            </h2>
            <p className="text-lg text-gray-600 max-w-xl mx-auto" data-id="element-100">
              Reach out to us through any of these channels. We aim to respond
              to all inquiries within 24 hours.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-101">
            {/* Email */}
            <div className="bg-gray-50 border border-gray-100 rounded-2xl p-8 text-center hover:shadow-md transition-shadow duration-300" data-id="element-102">
              <div className="mx-auto h-16 w-16 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-103">
                <MailIcon className="h-8 w-8 text-emerald-500" data-id="element-104" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-105">Email</h3>
              <a href="mailto:support@promptairtime.com" className="text-gray-600 hover:text-emerald-600 transition-colors" data-id="element-106">
                support@promptairtime.com
              </a>
            </div>

            {/* Phone */}
            <div className="bg-gray-50 border border-gray-100 rounded-2xl p-8 text-center hover:shadow-md transition-shadow duration-300" data-id="element-107">
              <div className="mx-auto h-16 w-16 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-108">
                <PhoneIcon className="h-8 w-8 text-emerald-500" data-id="element-109" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-110">Phone</h3>
              <a href="tel:+254713735116" className="text-gray-600 hover:text-emerald-600 transition-colors" data-id="element-111">
                +254 713 735 116
              </a>
            </div>

            {/* Location */}
            <div className="bg-gray-50 border border-gray-100 rounded-2xl p-8 text-center hover:shadow-md transition-shadow duration-300" data-id="element-112">
              <div className="mx-auto h-16 w-16 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-113">
                <MapPinIcon className="h-8 w-8 text-emerald-500" data-id="element-114" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-115">Location</h3>
              <p className="text-gray-600" data-id="element-116">
                Unga House, Westlands,
                <br data-id="element-117" />
                Nairobi, Kenya
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Business Hours */}
      <section className="py-20 bg-gray-50 border-t border-gray-100" data-id="element-118">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-119">
          <div className="mx-auto h-16 w-16 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-120">
            <ClockIcon className="h-8 w-8 text-emerald-500" data-id="element-121" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-122">
            Business Hours
          </h2>
          <div className="space-y-2 text-lg text-gray-600" data-id="element-123">
            <p data-id="element-124">Monday – Friday: 8:00 AM – 6:00 PM</p>
            <p data-id="element-125">Saturday: 9:00 AM – 1:00 PM</p>
            <p data-id="element-126">Sunday: Closed</p>
          </div>
        </div>
      </section>
    </div>;
}